import { defineStore } from 'pinia'
import { aggregatePageApi } from '~/api/common/aggregate-page'

let menuPagesRequest = null

function normalizeAggregatePageListPayload(payload) {
  if (Array.isArray(payload)) return payload
  if (!payload || typeof payload !== 'object') return []
  if (Array.isArray(payload.items)) return payload.items
  if (Array.isArray(payload.records)) return payload.records
  if (payload.data) return normalizeAggregatePageListPayload(payload.data)
  return []
}

function isHotProductsAggregatePage(page) {
  return page?.pageType === 'FIXED' && page?.pageKey === 'HOT_PRODUCTS'
}

function isCategoryAggregatePage(page) {
  return page?.pageType === 'CATEGORY' && (page?.categoryId || page?.pageKey)
}

/**
 * @description 商城聚合页菜单配置 Store，供 Header、商详等入口共享并缓存。
 */
export const useStoreAggregatePageStore = defineStore('storeAggregatePage', {
  state: () => ({
    menuPages: [],
    menuPagesLoaded: false,
    menuPagesLoading: false,
    menuPagesFailed: false,
  }),

  getters: {
    hotProductsPage: (state) => state.menuPages.find(isHotProductsAggregatePage) || null,
    hotProductsPageName() {
      return String(this.hotProductsPage?.pageName || '').trim()
    },
    categoryPages: (state) => state.menuPages.filter(isCategoryAggregatePage),
    shouldUseMenuPages: (state) => state.menuPagesLoaded && !state.menuPagesFailed,
    isMenuPagesPending: (state) => !state.menuPagesLoaded && !state.menuPagesFailed,
  },

  actions: {
    fetchMenuPages({ force = false, requestConfig = {} } = {}) {
      if (this.menuPagesLoaded && !force) return Promise.resolve(this.menuPages)
      if (menuPagesRequest) return menuPagesRequest

      this.menuPagesLoading = true
      menuPagesRequest = aggregatePageApi
        .list({ salesOrganization: 'TDC' }, requestConfig)
        .then((response) => {
          this.menuPages = normalizeAggregatePageListPayload(response)
          this.menuPagesFailed = false
          return this.menuPages
        })
        .catch((error) => {
          this.menuPages = []
          this.menuPagesFailed = true
          console.error('[store/aggregatePage] Failed to fetch aggregate page menu:', error)
          return this.menuPages
        })
        .finally(() => {
          this.menuPagesLoaded = true
          this.menuPagesLoading = false
          menuPagesRequest = null
        })

      return menuPagesRequest
    },
  },
})
